<template>
  <div id="content">
    <div class="page-title">常见问题<div style="height: 8px"></div></div>
    <div divalign="center" style="font-size: 16px">
      <div class="page-title1">  绑定不上<div style="height: 8px"></div></div>
        <p class="page-title2">设备绑定不上，请先尝试排查以下原因：</p>
        <p class="page-title2">1. 检查Wifi密码输入是否正确；</p>
        <p class="page-title2">2. Wifi名称不要用中文或者特殊字符设置；</p>
        <p class="page-title2">3. 检查路由器与设备的距离，建议距离保持在5米以内且无隔墙；</p>
       <p class="page-title2"> 4. 路由器是否为双频路由器（2.4G和5G），如果是，请关闭5G双频，然后再进行绑定；</p>
       <p class="page-title2"> 5. 不使用WEP，WPSK的安全加密方式</p>
       <p class="page-title2"> 6. 企业路由器安全加密方式不支持绑定</p>
       <p class="page-title2"> 7. Wifi绑定无法绑定的情况下，请尝试使用手机热点分享的方式进行绑定</p>

    </div>

  </div>
</template>

<script>
  export default {
    name: 'no_bind'
  }
</script>

<style scoped>
  .page-title {
    font-weight:900;
    font-size: 18px;
    margin: 20px auto;
    text-align: center;
    display: block;
    line-height: 1;
    left: 118px;
    border-width: 0 0 1px 0;
    font-family:blod  黑体 ;

    border-style: solid;
    border-color: #F5F5F5;
  }
  .page-title1 {
    font-family:blod  黑体 ;
    font-size: 18px;
    margin: 20px auto;
    line-height: 1;
    left: 14px;
    border-width: 0 0 1px 0;
    font-weight:100;

    border-style: solid;
    border-color: #F5F5F5;
  }
  .page-title2{
    left: 14px;
    height: 26px;
    font-family: 简体;
    font-size: 16px;
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonproblem/nobind/nobind.vue